export const apiURL = 'https://api.waqi.info/feed/';
export const apiKey = '1b5d2d4966cfc6ea26a95d5e1bd7a4b8ea579448';
